<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: { type: String, required: true },
});

const { t } = useI18n();

const statusClass = computed(() => {
  const classes = {
    completed: 'bg-n-teal-3 text-n-teal-11',
    published: 'bg-n-teal-3 text-n-teal-11',
    processing: 'bg-n-blue-3 text-n-blue-11',
    queued: 'bg-n-amber-3 text-n-amber-11',
    draft: 'bg-n-amber-3 text-n-amber-11',
    failed: 'bg-n-ruby-3 text-n-ruby-11',
    archived: 'bg-n-slate-3 text-n-slate-11',
  };

  return classes[props.status] || classes.archived;
});

const label = computed(() =>
  t(`AI_REVIEWS.STATUS.${props.status.toUpperCase()}`)
);
</script>

<template>
  <span
    class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full"
    :class="statusClass"
  >
    {{ label }}
  </span>
</template>
